// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"hr-z","imageAndVideoCount":"ir-z","imageAndVideoContainer":"jr-z","viewAllReviews":"kr-z"};